import { render, staticRenderFns } from "./molis_table_manage.vue?vue&type=template&id=2a7f1116&scoped=true&"
import script from "./molis_table_manage.vue?vue&type=script&lang=ts&"
export * from "./molis_table_manage.vue?vue&type=script&lang=ts&"
import style0 from "./molis_table_manage.vue?vue&type=style&index=0&id=2a7f1116&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f1116",
  null
  
)

export default component.exports